import styled from 'styled-components';

export const StyledRemovalChronicDiseaseForm = styled.form`
   margin-top: 18px;
   gap: 18px;
   display: flex;
   flex-direction: column;
`;
StyledRemovalChronicDiseaseForm.displayName = 'StyledRemovalChronicDiseaseForm';
